/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { copyURL } from 'src/api/functions/func/function.copyUrl';

const ContextMenuWorkspace = ({ workspaceIndex, position, onClose, showDialog, setShowDialog }) => {
  const workspace = useSelector((state: any) => state.workspaces.instances[workspaceIndex]);
  const workspaces = useSelector((state: any) => state.workspaces);
  const menuRef = useRef(null);

  const groupColor = JSON.parse(localStorage.getItem('activeWorkspace') || '{}')?.color || '#6b7280';

  useEffect(() => {
    const handleClickOutside = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) onClose();};
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const handleAction = (id) => {
    if (id === 'group') setShowDialog(true);
    if (id === 'copyUrl') copyURL();
    onClose();
  };

  const items = [
    ...(workspace?.isActive && workspaces.instances.length > 1 ? [{ label: 'Tab verwalten', id: 'group', icon: 'e-settings' }]: []),
    { label: 'Copy URL', id: 'copyUrl', icon: 'e-link-3' }
  ];

  return !showDialog && (
    <ul
      ref={menuRef}
      className="fixed z-50 bg-white shadow-lg border rounded-[8px] py-1 min-w-[200px]"
      style={{ top: `${position.y}px`, left: `${position.x}px` }}
    >
      {items.map(({ id, label, icon }) => (
        <li key={id}>
          <button
            onClick={() => handleAction(id)}
            className="flex items-center gap-2 w-full text-left px-4 py-2 hover:bg-gray-100 text-gray-500"
          >
            <span className={`e-icons ${icon}`} style={{ color: id === 'group' ? groupColor : undefined }} />
            {label}
          </button>
        </li>
      ))}
    </ul>
  );
};

ContextMenuWorkspace.propTypes = {
  workspaceIndex: PropTypes.number.isRequired,
  position: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  showDialog: PropTypes.any,
  setShowDialog: PropTypes.func.isRequired,
};

export default ContextMenuWorkspace;
